import { render, staticRenderFns } from "./CreateInvoiceWrapper.vue?vue&type=template&id=28314d17&scoped=true&"
import script from "./CreateInvoiceWrapper.vue?vue&type=script&lang=js&"
export * from "./CreateInvoiceWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28314d17",
  null
  
)

export default component.exports